import { Helmet } from "react-helmet-async";
import { jsonLd } from "@/lib/seoHelpers";

const BASE_URL = "https://www.garden-review.co.uk";

/**
 * Global structured data schemas for the entire site.
 * Includes: Organization, WebSite with SearchAction, and Publisher info.
 * Place this in the root App component or layout.
 */
export const GlobalSchemas = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": ["Organization", "NewsMediaOrganization"],
    "@id": `${BASE_URL}/#organization`,
    "name": "Garden-Review",
    "alternateName": "Garden Review UK",
    "url": BASE_URL,
    "logo": {
      "@type": "ImageObject",
      "url": `${BASE_URL}/favicon.png`,
      "width": 512,
      "height": 512
    },
    "sameAs": [
      // Add social media URLs when available
    ],
    "description": "Independent UK gardening publication covering hands-on garden machinery reviews, buying guides, plant care advice and month-by-month seasonal tasks.",
    "foundingDate": "2024",
    "parentOrganization": {
      "@type": "Organization",
      "name": "Media-M Global Ltd"
    },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Suite 693, 80A Ruskin Ave",
      "addressLocality": "Welling",
      "postalCode": "DA16 3QQ",
      "addressCountry": "GB"
    },
    "areaServed": {
      "@type": "Country",
      "name": "United Kingdom"
    },
    "publishingPrinciples": `${BASE_URL}/about`,
    "actionableFeedbackPolicy": `${BASE_URL}/about`,
    "ownershipFundingInfo": `${BASE_URL}/about`,
    "diversityPolicy": `${BASE_URL}/about`,
    "knowsLanguage": "en-GB",
    "knowsAbout": [
      "Gardening",
      "Plant Care",
      "Garden Design",
      "Lawn Care",
      "Vegetable Gardening",
      "Flower Gardening",
      "Garden Tools",
      "Lawn Mowers",
      "Pressure Washers",
      "Chainsaws",
      "Generators",
      "Landscaping"
    ]
  };


  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${BASE_URL}/#website`,
    "url": BASE_URL,
    "name": "Garden-Review",
    "description": "UK gardening guides, hands-on product reviews and seasonal plant care tips to help your garden thrive. Explore buying guides, how-tos and tool reviews.",
    "publisher": {
      "@id": `${BASE_URL}/#organization`
    },
    "inLanguage": "en-GB",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${BASE_URL}/articles?search={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {jsonLd(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {jsonLd(websiteSchema)}
      </script>
    </Helmet>
  );
};

export default GlobalSchemas;
